import React from 'react';
import langConf from "../js/lang";

const BackButton = ({lang, currentURL, onClick}) => {
    return <a href={currentURL} className="btn btn-info btn-block btn-lg" onClick={onClick}>{langConf[lang].back}</a>;
};

export default BackButton;